import { render } from "./CollectionSourceDisplay.vue?vue&type=template&id=10fce336&scoped=true"
import script from "./CollectionSourceDisplay.vue?vue&type=script&lang=js"
export * from "./CollectionSourceDisplay.vue?vue&type=script&lang=js"

import "./CollectionSourceDisplay.vue?vue&type=style&index=0&id=10fce336&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10fce336"]])

export default __exports__